<template>
	<div class="row">
		<Popper :content="errors.size" arrow placement="top" class="w-100 m-0 border-0" :show="errors.size ? true : false">
			<div class="w-100"></div>
		</Popper>
		<template v-for="(option, key) in options">
			<template v-if="option.back == '(Same as front tyre)'">
				<div class="col-12" :key="key">
					<confirm-size-radio :same-front-rear="true" :radio-id="'size_' + key" :radio-value="option.front" :checked="this.options.length == 1 ? true : false" @click="updateTyrePosition({position: 'same', value: option.front })"></confirm-size-radio>
				</div>
			</template>
			<template v-else>
				<!-- hidePosition used for size options on BasketModal -->
				<div v-if="((single_option == '' || single_option == 'front') && hidePosition != 'front')" class="col-6" :key="key">
					<confirm-size-radio :same-front-rear="false" :radio-id="'size_' + key" :radio-value="option.front" @click="updateTyrePosition({position: 'front', value: option.front })"></confirm-size-radio>
				</div>
				<div v-if="((single_option == '' || single_option == 'back') && hidePosition != 'rear')" tyre-position="back" class="col-6" :key="key">
					<confirm-size-radio :same-front-rear="false" :radio-id="'size_' + key" :radio-value="option.back" @click="updateTyrePosition({position: 'rear', value: option.back })"></confirm-size-radio>
				</div>
			</template>
		</template>
	</div>
</template>
<script>
    import { Form as VeeForm, Field, ErrorMessage } from 'vee-validate';

    export default {
	    props: ['options', 'errors', 'hidePosition', 'updateSizeOptions'],
	    components: { VeeForm, Field, ErrorMessage},
	    data() {
	        return {
	            single_option: ''
	        }
	    },
	    methods: {
			updateTyrePosition(data) {
				this.emitter.emit('updateTyrePosition', data.position);

				//For use on the BasketModal, pre-selecting size form with selected width/profile/rim
				if(this.updateSizeOptions == true) {
					this.$emit('updateSelectedOption', data.value);
				}
			}
	    },
	    computed: {

	    }
	}
</script>
<style lang="scss">
</style>